import { render } from "./leave-request.vue?vue&type=template&id=599f2e70"
import script from "./leave-request.vue?vue&type=script&lang=js"
export * from "./leave-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__